import { Alert, AlertTitle, Box, Button } from '@mui/material'
import { Refresh } from '@mui/icons-material'

interface ErrorMessageProps {
  title?: string
  message: string
  onRetry?: () => void
  variant?: 'error' | 'warning' | 'info'
}

const ErrorMessage = ({ 
  title = 'Error', 
  message, 
  onRetry, 
  variant = 'error' 
}: ErrorMessageProps) => {
  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <Alert 
        severity={variant}
        action={
          onRetry && (
            <Button
              color="inherit"
              size="small"
              onClick={onRetry}
              startIcon={<Refresh />}
            >
              Retry
            </Button>
          )
        }
      >
        <AlertTitle>{title}</AlertTitle>
        {message}
      </Alert>
    </Box>
  )
}

export default ErrorMessage